import axios, { AxiosResponse } from "axios";

class Services {
  static async getPackages(
    hospitalId: number,
    categoryId: number,
    genderFilter: string,
    keyword: string,
    lang: string,
    accessToken: string
  ): Promise<AxiosResponse<any, any>> {
    try {
      const res = await axios.post(
        process.env.VUE_APP_TOTALHEALTHAPI_URL +
          "/total-health-solution/hospital-package/get-packages",
        {
          hospitalPackageBean: {
            hospitalId: hospitalId,
            categoryId: categoryId,
            genderFilter: genderFilter,
            keyword: keyword,
          },
        },
        {
          headers: {
            "Accept-Language": lang,
            Authorization: "Bearer " + accessToken,
          },
        }
      );
      return res;
    } catch (e) {
      throw e as Error;
    }
  }
}

export default Services;
